import { isPresent } from "../../pages/calendar/appointmentServiceFields";

export const childResourceOptionState = (response, service = {}) => {
  const resourceOptions = Array.isArray(response) || Array.isArray(response?.resource_requirements)
    ? response : [];
  const resource_requirements = Array.isArray(resourceOptions?.resource_requirements)
    ? resourceOptions.resource_requirements : [];
  const resource_required = isPresent(service.resource_id)
    || (Array.isArray(service.resource_requirements) && service.resource_requirements.length > 0)
    || resource_requirements.length > 0;
  const resource_unavailable = resource_requirements.length
    ? resource_requirements.some((requirement) => !Array.isArray(requirement.resource_items) || !requirement.resource_items.length)
    : resource_required && resourceOptions.length === 0;
  return { resourceOptions, resource_requirements, resource_required, resource_unavailable };
};
